var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSupprimer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 50 50",
    style: {
      enableBackground: "new 0 0 50 50"
    },
    xmlSpace: "preserve",
    width: 150,
    height: 150,
    className: "mainStroke",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.327 17.327c-.49.49-.583.371 3.234 4.192L24.039 25l-3.478 3.481c-3.811 3.816-3.713 3.688-3.221 4.179.491.492.363.59 4.179-3.221L25 25.961l3.481 3.478c3.816 3.811 3.688 3.713 4.179 3.221.492-.491.59-.363-3.221-4.179L25.961 25l3.478-3.481c3.811-3.816 3.713-3.688 3.221-4.179-.491-.492-.363-.59-4.179 3.221L25 24.039l-3.481-3.478c-3.821-3.817-3.702-3.724-4.192-3.234",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSupprimer);
export default __webpack_public_path__ + "static/media/supprimer.e84d18895d69b094b22934babc3c164e.svg";
export { ForwardRef as ReactComponent };